const mediaItems = [
  {
    title: '《秘密教学》',
    tag: '韩漫热榜TOP1',
    tagColor: 'bg-accent-100 text-accent-700',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20drama%20cover%20illustration%2C%20young%20couple%20in%20school%20uniform%20with%20soft%20warm%20lighting%2C%20pastel%20tone%2C%20clean%20white%20background%2C%20modern%20webtoon%20cover%20art%2C%20emotional%20atmosphere%2C%20professional%20illustration%20quality&width=600&height=800&seq=media-manga-01&orientation=portrait',
    desc: '豪门继承人与女教师的禁忌之恋，全网热议韩漫神作',
    readers: '128万',
  },
  {
    title: '《咒术回战》',
    tag: '日漫连载中',
    tagColor: 'bg-primary-100 text-primary-700',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20shonen%20manga%20action%20cover%20illustration%2C%20supernatural%20battle%20scene%20with%20dynamic%20energy%20effects%2C%20dark%20fantasy%20style%2C%20warm%20orange%20and%20red%20accents%2C%20clean%20background%2C%20modern%20anime%20art%20style%2C%20professional%20manga%20cover%20quality&width=600&height=800&seq=media-manga-02&orientation=portrait',
    desc: '咒术师与诅咒的生死对抗，热血战斗番不容错过',
    readers: '256万',
  },
  {
    title: '《斗破苍穹》',
    tag: '国漫大图',
    tagColor: 'bg-secondary-100 text-secondary-700',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20martial%20arts%20fantasy%20cover%20illustration%2C%20warrior%20in%20flowing%20robes%20with%20flame%20aura%2C%20epic%20cultivation%20theme%2C%20golden%20and%20amber%20tones%2C%20clean%20minimal%20background%2C%20modern%20Chinese%20comic%20art%20style%2C%20high%20quality%20illustration&width=600&height=800&seq=media-manga-03&orientation=portrait',
    desc: '萧炎逆天改命的修炼之路，国漫经典大作全彩连载',
    readers: '189万',
  },
  {
    title: '《女神降临》',
    tag: '韩漫完结',
    tagColor: 'bg-accent-100 text-accent-700',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20illustration%2C%20beautiful%20girl%20with%20makeup%20transformation%20theme%2C%20soft%20pink%20and%20peach%20tones%2C%20school%20life%20setting%2C%20clean%20pastel%20background%2C%20modern%20manhwa%20art%20style%2C%20emotional%20romantic%20atmosphere&width=600&height=800&seq=media-manga-04&orientation=portrait',
    desc: '化妆逆袭的校园恋爱喜剧，看完直呼甜甜甜',
    readers: '95万',
  },
  {
    title: '《一人之下》',
    tag: '国漫人气',
    tagColor: 'bg-secondary-100 text-secondary-700',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20manhua%20cover%20illustration%2C%20modern%20urban%20fantasy%20with%20Taoist%20elements%2C%20mysterious%20characters%20with%20special%20abilities%2C%20dark%20amber%20and%20jade%20green%20tones%2C%20clean%20minimal%20background%2C%20modern%20Chinese%20comic%20style%2C%20professional%20illustration&width=600&height=800&seq=media-manga-05&orientation=portrait',
    desc: '异人世界的秘密逐步揭开，国漫封神之作全网好评',
    readers: '112万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-3 mb-10 md:mb-12">
          <div>
            <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-2">
              热门连载速览
            </h2>
            <p className="text-sm text-foreground-500">本周最受瞩目的五部连载作品</p>
          </div>
          <a
            href="#index"
            className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors group cursor-pointer"
            >
              <div className="aspect-[3/4] overflow-hidden bg-background-200">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium mb-2 ${item.tagColor}`}>
                  {item.tag}
                </span>
                <h3 className="font-heading text-base text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-2">{item.desc}</p>
                <div className="flex items-center gap-1.5 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.readers} 阅读</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}